import { useDraggable } from '@dnd-kit/core'
import React from 'react'

import { Bookable } from '../../models/Bookable'
import { Item } from '../../models/Item'
import { PSEvent } from '../../models/PSEvent'
import { isPast } from '../../utils/dates'

type Props = {
    children: React.ReactNode
    id: string
    bookable: Bookable
    style?: React.CSSProperties
    disabled?: boolean
}

export const CalendarDraggable = ({
    children,
    id,
    bookable,
    style = {},
    disabled = false,
}: Props) => {
    const { attributes, listeners, setNodeRef, isDragging } = useDraggable({
        id,
        data: { bookable },
        disabled:
            disabled ||
            bookable instanceof Item ||
            bookable instanceof PSEvent ||
            isPast(bookable.date),
    })

    return (
        <div
            ref={setNodeRef}
            style={{ ...style, opacity: disabled || isDragging ? 0.5 : undefined }}
            {...listeners}
            {...attributes}
        >
            {children}
        </div>
    )
}
